import {
  GetWidgetResponse,
  Widget,
  WidgetEffort,
  WidgetManifest,
  WidgetMessage,
  WidgetStatus,
  WidgetTimings,
} from 'src/components/widgets/widgetTypes';

import { ApiMethods, appAPI } from './appApi';

export type {
  Widget,
  WidgetEffort,
  WidgetManifest,
  WidgetMessage,
  WidgetStatus,
  WidgetTimings,
};

export interface CreateWidgetRequest {
  prompt: string;
  model?: string;
  effort?: WidgetEffort;
  fast?: boolean;
}

export interface CreateWidgetResponse {
  widget: Widget;
}

export type { GetWidgetResponse };

export interface ListWidgetsResponse {
  data: Widget[];
}

export interface SendWidgetMessageRequest {
  id: string;
  content: string;
}

export interface SendWidgetMessageResponse {
  widget: Widget;
}

export const widgetsApi = appAPI.injectEndpoints({
  endpoints: (build) => ({
    createWidget: build.mutation<CreateWidgetResponse, CreateWidgetRequest>({
      query: (body) => ({
        path: '/v1/widgets',
        method: ApiMethods.post,
        options: { body },
      }),
    }),
    getWidget: build.query<GetWidgetResponse, string>({
      query: (id) => ({
        path: `/v1/widgets/${id}`,
        method: ApiMethods.get,
        options: {},
      }),
    }),
    sendWidgetMessage: build.mutation<
      SendWidgetMessageResponse,
      SendWidgetMessageRequest
    >({
      query: ({ id, content }) => ({
        path: `/v1/widgets/${id}/messages`,
        method: ApiMethods.post,
        options: { body: { content } },
      }),
    }),
    listWidgets: build.query<ListWidgetsResponse, void>({
      query: () => ({
        path: '/v1/widgets',
        method: ApiMethods.get,
        options: {},
      }),
    }),
  }),
});

export const {
  useCreateWidgetMutation,
  useGetWidgetQuery,
  useListWidgetsQuery,
  useSendWidgetMessageMutation,
} = widgetsApi;
